var map = {
	"./BAT.png": "bb68",
	"./BTC.png": "a28e",
	"./Bg5.png": "34a5",
	"./ETH.png": "6576",
	"./LINK.png": "f337",
	"./MKR.png": "e472",
	"./back.png": "336c",
	"./beta-13.png": "f267",
	"./dextools.png": "4bcf",
	"./etherscan.png": "46ad",
	"./fat_guy_sil.png": "b89c",
	"./favicon.png": "99dd",
	"./gamma-26.png": "23a5",
	"./kappa-36.png": "3a98",
	"./kek.png": "8275",
	"./liquidity.png": "0aca",
	"./muscle_guy_sil.png": "85ad",
	"./paper.png": "c079",
	"./rho_icon-06.png": "53e4",
	"./telegram.png": "c2ea",
	"./uniswap.png": "cd3c",
	"./wallet.png": "0131",
	"./xi_token_icon_v0.1-48.png": "10aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";